interface Props {
  width?: string;
  height?: string;
}

const AIIcon = ({ height, width }: Props) => {
  return (
    <svg
      width={width || "52"}
      height={height || "50"}
      viewBox="0 0 52 50"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Robot head/body */}
      <rect
        x="11"
        y="12"
        width="30"
        height="26"
        rx="4"
        ry="4"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Robot antenna */}
      <circle cx="26" cy="7" r="2.5" fill="currentColor" />
      <line
        x1="26"
        y1="9.5"
        x2="26"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Eyes */}
      <circle cx="20" cy="20" r="2.5" fill="white" />
      <circle cx="32" cy="20" r="2.5" fill="white" />
      <circle cx="20" cy="20" r="1" fill="currentColor" />
      <circle cx="32" cy="20" r="1" fill="currentColor" />

      {/* Mouth/speaker lines */}
      <line
        x1="18"
        y1="28"
        x2="34"
        y2="28"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="20"
        y1="31"
        x2="32"
        y2="31"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="22"
        y1="34"
        x2="30"
        y2="34"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      {/* Arms */}
      <rect
        x="5"
        y="20"
        width="6"
        height="10"
        rx="3"
        ry="3"
        fill="currentColor"
      />
      <rect
        x="41"
        y="20"
        width="6"
        height="10"
        rx="3"
        ry="3"
        fill="currentColor"
      />

      {/* Legs */}
      <rect
        x="17"
        y="38"
        width="5"
        height="8"
        rx="2.5"
        ry="2.5"
        fill="currentColor"
      />
      <rect
        x="30"
        y="38"
        width="5"
        height="8"
        rx="2.5"
        ry="2.5"
        fill="currentColor"
      />

      {/* AI text indicator - small "AI" letters */}
      <text
        x="26"
        y="26"
        fontSize="6"
        textAnchor="middle"
        fill="white"
        fontFamily="Rubik, sans-serif"
        fontWeight="bold"
      >
        AI
      </text>
    </svg>
  );
};

export default AIIcon;
